
import { Injectable } from "@angular/core";
import { ApiService } from "@tylertech/core-module";
import { ExecutionResult, GetNoteObjectViewModel, NoteViewModel, SaveNoteViewModel } from "@tylertech/tyler-api-types";

/**
 * NoteService is a generated service implementation. Any edits will be overridden!
 */
@Injectable()
export class NoteService {
    constructor(private readonly $apiService: ApiService) { }
    
    Delete(idType: GetNoteObjectViewModel): Promise<ExecutionResult<boolean>> {
        return this.$apiService.sendAuth("INoteService/Delete", idType);
    }
    Get(idType: GetNoteObjectViewModel): Promise<ExecutionResult<NoteViewModel[]>> {
        return this.$apiService.sendAuth("INoteService/Get", idType);
    }
    Save(idType: SaveNoteViewModel): Promise<ExecutionResult<boolean>> {
        return this.$apiService.sendAuth("INoteService/Save", idType);
    }
}
